<template>
  <div class="downApp">
    <div class="app-down">
      <img v-if="downType == 'teacher'" src="@/assets/teacherLogo.png" alt="" />
      <img v-else src="@/assets/studentLogo.png" alt="" />
      <van-button type="primary" class="btn" block @click="down"
        >下载APP</van-button
      >
      <!-- <van-button type="primary" class="btn" block>块级元素</van-button> -->
    </div>
    <div v-if="isWx" class="isWx">
      <img src="@/assets/jt.png" alt="" />
      <p>
        温馨提示：<br />
        请点击微信右上角按钮，在弹出的菜单中，点击在
        <em>浏览器打开</em>，即可下载安装
      </p>
    </div>
  </div>
</template>

<script>
import { getAppVersion } from "@/api/interface";
export default {
  name: "DownApp",
  data() {
    return {
      isWx: false,
    };
  },
  created() {
    this.getPhoneType();
    this.getISWxType();
    this.getdownType();
    this.getUrl();
    // console.log("1111");
  },
  methods: {
    getUrl() {
      let data = {
        userType: 2,
      };
      // userType 1是学生 2 是老师
      if (this.downType == "teacher") {
        data.userType = 1;
      }
      getAppVersion(data).then((res) => {
        if (this.downType == "teacher") {
          this.anTeaUrl = res.data.link;
        } else {
          this.anStuUrl = res.data.link;
        }
      });
    },
    down() {
      // Toast("app内测中，请等待公开！");
      // this.anStuUrl =
      //   "https://static.wtjy.com/resource/installler/1.0.0/stu_release_01211631.apk";
      // this.anTeaUrl =
      //   "https://static.wtjy.com/resource/installler/1.0.0/tch_release_02091802.apk";
      this.IosStuUrl =
        "https://apps.apple.com/us/app/%E6%96%87%E9%80%9A%E4%BA%91%E5%AD%A6%E7%94%9F%E7%AB%AF/id1596729234";
      this.IosTeaUrl =
        "https://apps.apple.com/us/app/%E6%96%87%E9%80%9A%E4%BA%91%E6%95%99%E5%B8%88%E7%AB%AF/id1596724273";
      // if(this.isiOS){
      //   Toast("IOSAPP上架中，预计12月10日完成！")
      //   return
      // }
      if (this.downType == "teacher") {
        if (this.isiOS) {
          this.downladUrl(this.IosTeaUrl, "文通云教师端");
        } else {
          this.downladUrl(this.anTeaUrl, "文通云教师端");
        }
      } else {
        if (this.isiOS) {
          this.downladUrl(this.IosStuUrl, "文通云学生端");
        } else {
          this.downladUrl(this.anStuUrl, "文通云学生端");
        }
      }
    },
    downladUrl(url, fileName) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.download = fileName;
      link.style.display = "none";
      document.body.append(link);
      link.click();
    },
    getdownType() {
      this.downType = this.$route.query.type;
    },
    getISWxType() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua); //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.isWx = true;
        // console.log("微信浏览器");
        // return true;
      } else {
        // console.log("不是微信浏览器");
        // return false;
      }
    },
    getPhoneType() {
      let u = navigator.userAgent;
      // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // console.log(this.isiOS);
    },
  },
};
</script>
<style scoped lang="scss">
.downApp {
  position: relative;
  .app-down {
    padding-top: 100px;
    .btn {
      width: 50%;
      margin: 60px auto;
      border-color: rgba(16, 198, 148, 100);
      background-color: rgba(16, 198, 148, 100);
    }
    img {
      width: 100px;
      border-radius: 4px;
      display: block;
      margin: 0 auto;
    }
  }
  .isWx {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
    height: 100vh;
    width: 100vw;
    z-index: 10;
    padding-top: 80px;
    top: 0;
    left: 0;
    img {
      width: 100px;
      position: absolute;
      right: 5px;
      top: 10px;
    }
    p {
      // position: absolute;
      margin: 0 auto;
      // top: 80px;
      color: #ffffff;
      margin-top: 24px;
      width: 80%;
      font-size: 12px;
      em {
        color: #49e9b9;
      }
    }
  }
}
</style>
